import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationModel, SimplePaginationModel } from 'src/app/models/pagination.model';
import { PriceList, PriceListView, producPriceRequest, ProductPriceListResponse, ProductPriceResponse } from 'src/app/models/price-list.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { InvoiceSaleService } from '../../invoice-sale/invoice-sale.service';
import { ProductResponse } from 'src/app/models/product.model';

@Component({
  selector: 'app-price-list-products-group',
  templateUrl: './price-list-products-group.component.html',
  styleUrls: ['./price-list-products-group.component.scss']
})
export class PriceListProductsGroupComponent implements OnInit, OnChanges {
  @Input() productPriceList!: ProductPriceListResponse;
  productPricesList: ProductPriceResponse[] = [];
  filterProductList: any;
  productList: any;
  productSelected: ProductPriceResponse = null;
  productSelectedId: number = null;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  inputs = {
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        price: null
      }
    },
  };
  price = null;
  products: ProductResponse[] = [];
  filterProducts: ProductResponse[] = [];
  filterProductPricesList: ProductPriceResponse[];
  loadingProducts = false;
  loadingSave = false;
  timeout = null;
  filterWord: string = null;
  editPrice: { [key: number]: boolean } = {};
  expandedRows = new Set<number>();

  constructor(
    private productService: InvoiceSaleService,
    private inventoryService: InventoryService, 
    private toastService: ToastrService){}

  ngOnInit(): void {
      this.getPriceList();
      this.getProducts("");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['productPriceList']) {
      this.getPriceList();
    }
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  getPriceList(){
    if(!this.productPriceList) {
      return;
    }

    this.loadingProducts = true;
    this.inventoryService.getProductPrices(this.productPriceList.id).subscribe({
      next: (response: ResponseObject) => {
        this.productPricesList = response.data;
        this.pagination.filter = this.productPricesList;
        this.pagination.total = this.productPricesList;
        this.resetPagination();
        this.loadingProducts = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener las listas de precios.", "Error")
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  setPriceListSelected(productPrice: ProductPriceResponse){
    this.productSelected = productPrice;
    this.productSelectedId = this.productSelected.id;
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  writeProduct(input) {
      var inputValue = input.target.value;
      clearTimeout(this.timeout);
      this.inputs.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.getProducts(inputValue);
      }, 500);
    }

  checkProduct(product: any) {
    this.changeInput(this.inputs.product, product.code + " - " + product.name, true, null, "fa-circle-check", product);
  }

  addPrice() {
    if (!this.productPriceList || this.price < 0){
      return;
    }

    let data: producPriceRequest= {
      listId: this.productPriceList.id,
      price: this.price,
      productId: this.inputs.product.data.id
    } 
    this.loadingSave = true;
    this.inventoryService.postProductPrices(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Producto agregado correctamente.", "Exito");
        this.getPriceList();
        this.loadingSave = false;
        this.resetInput();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se agrego el precio a la lista")
      }
    });
  }

  resetInput(){
    this.inputs.product = {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        price: null
      }
    }
    this.price = null;
  }

  deletePrice(productPrice: ProductPriceResponse) {
    if (!this.productPriceList || !productPrice){
      return;
    }

    this.loadingSave = true;
    this.inventoryService.deleteProductPrices(productPrice.id, this.productPriceList.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Producto eliminado correctamente.", "Exito");
        this.getPriceList();
        this.loadingSave = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se elimino el precio de la lista")
      }
    });
  }

  editingPrice(productPrice: ProductPriceResponse) {
    if(this.editPrice[productPrice.id]) {
      this.editPrice[productPrice.id] = false;
      return;
    }
    this.editPrice[productPrice.id] = true;
  }

  updatePrice(productPrice: ProductPriceResponse) {
    if (!productPrice || productPrice.price < 0){
      return;
    }

    let data: producPriceRequest= {
      listId: this.productPriceList.id,
      price: productPrice.price,
      productId: productPrice.id
    } 

    this.loadingSave = true;
    this.inventoryService.putProductPrices(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Producto actualizado correctamente.", "Exito");
        this.getPriceList();
        this.loadingSave = false;
        this.editPrice[productPrice.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se actualizo el precio a la lista")
      }
    });
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.productPricesList.filter((productPrice) => {
      const filter = this.filterWord.toLowerCase();

      return (
        productPrice.id + '' === this.filterWord ||
        productPrice.name.toLowerCase().includes(filter) || 
        productPrice.code.toLowerCase().includes(filter)
      );
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }


}
